import type {EmbedProps} from '@interfaces/Embed';
import type ValueList from '@interfaces/ValueList';
import type {ComponentType, LazyExoticComponent} from 'react';
import {lazy} from 'react';
import {EmbedType} from '@constants/embedType';

type EmbedComponent = LazyExoticComponent<ComponentType<EmbedProps>>;

// prettier-ignore
const ClubForm = lazy(async () => import(/* webpackChunkName: "club-form" */ '@components/ClubForm'));
// prettier-ignore
const VpnForm = lazy(async () => import(/* webpackChunkName: "vpn-form" */ '@components/VpnForm'));
// prettier-ignore
const PaperTurboForm = lazy(async () => import(/* webpackChunkName: "paperturbo-form" */ '@components/PaperTurboForm'));
// prettier-ignore
const KluForm = lazy(async () => import(/* webpackChunkName: "klu-form" */ '@components/KluForm'));
// prettier-ignore
const CourseForm = lazy(async () => import(/* webpackChunkName: "course-form" */ '@components/CourseForm'));
// prettier-ignore
const CustomForm = lazy(async () => import(/* webpackChunkName: "custom-form" */ '@components/CustomForm'));
// prettier-ignore
const CustomFormRub = lazy(async () => import(/* webpackChunkName: "custom-form-rub" */ '@components/CustomForm/CloudPayments'));
// prettier-ignore
const CustomFormEur = lazy(async () => import(/* webpackChunkName: "custom-form-eur" */ '@components/CustomForm/Stripe'));
// prettier-ignore
const DonationFormRub = lazy(async () => import(/* webpackChunkName: "donation-form-rub" */ '@components/DonationForm/CloudPayments'));
// prettier-ignore
const DonationFormEur = lazy(async () => import(/* webpackChunkName: "donation-form-eur" */ '@components/DonationForm/Stripe'));
// prettier-ignore
const CardChange = lazy(async () => import(/* webpackChunkName: "vpn-card-change-button" */ '@components/VpnCardChangeButton'));
// prettier-ignore
const SubscriptionForm = lazy(async () => import(/* webpackChunkName: "subscription" */ '@components/SubscriptionForm/Form'));
// prettier-ignore
const TourForm = lazy(async () => import(/* webpackChunkName: "tour-form" */ '@components/TourForm'));

const list: ValueList<EmbedComponent> = {
    [EmbedType.Club]: ClubForm,
    [EmbedType.Vpn]: VpnForm,
    [EmbedType.Course]: CourseForm,
    [EmbedType.Custom]: CustomForm,
    [EmbedType.CustomRub]: CustomFormRub,
    [EmbedType.CustomEur]: CustomFormEur,
    [EmbedType.DonationRub]: DonationFormRub,
    [EmbedType.DonationEur]: DonationFormEur,
    [EmbedType.VpnCardChange]: CardChange,
    [EmbedType.Subscription]: SubscriptionForm,
    [EmbedType.PaperTurbo]: PaperTurboForm,
    [EmbedType.Klu]: KluForm,
    [EmbedType.Tour]: TourForm,
};

export function getEmbed(type: EmbedType): EmbedComponent {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!list[type]) {
        throw new Error(`Unknown embed type: ${type}`);
    }

    return list[type];
}
